import { api } from '@/lib/api/client';
import { unwrap } from '@/lib/api/envelope';
import { Endpoints } from '@/lib/api/endpoints';
import type { ResponseEnvelope } from '@/types/api';

export interface UsageBucket {
  bucket: string;
  total: number;
  success: number;
  failed: number;
}

export interface UsageAnalytics {
  series: UsageBucket[];
  byOperator: Record<string, number>;
  byServiceType: Record<string, number>;
  totalRequests: number;
  successfulRequests: number;
  failedRequests: number;
  averageLatencyMs: number;
}

export interface UsageAnalyticsParams {
  clientId?: string;
  from?: string;
  to?: string;
  granularity?: 'DAILY' | 'HOURLY';
}

export async function fetchUsageAnalytics(
  params: UsageAnalyticsParams = {},
): Promise<UsageAnalytics> {
  const res = await api.get<ResponseEnvelope<UsageAnalytics>>(Endpoints.analytics.usage, {
    params,
  });
  return unwrap(res);
}
